import auth from './auth'

// ============================================================
// 管理端查询接口（严格按 API.md 实现，JWT 鉴权走 auth.request 自动带 Bearer）
// ============================================================

// GET /api/client/logs  (API.md 7.3.1，后台读取，需 Bearer)
// Query: project / date / ip / page / pageSize
// 返回：{ success:true, data:[{id,ip,project_name,original_name,upload_date,log_file_path,created_at}], pagination:{page,pageSize,total,totalPages} }
export async function getLogs(params = {}) {
  const qs = new URLSearchParams()
  if (params.project) qs.set('project', params.project)
  if (params.date) qs.set('date', params.date)
  if (params.ip) qs.set('ip', params.ip)
  if (params.page) qs.set('page', params.page)
  if (params.pageSize) qs.set('pageSize', params.pageSize)
  const q = qs.toString()
  const res = await auth.request(`/api/client/logs${q ? '?' + q : ''}`)
  if (!res.ok) {
    const err = new Error(`拉取日志失败（HTTP ${res.status}）`)
    err.status = res.status
    throw err
  }
  const data = await res.json()
  return {
    list: (data && data.data) || [],
    total: (data && data.pagination && data.pagination.total) || 0,
  }
}

// GET /api/client/logs/:id/content  (API.md 7.3.2)
// 返回：.txt 原始文本（text/plain; charset=utf-8）
export async function getLogContent(id) {
  const res = await auth.request(`/api/client/logs/${encodeURIComponent(id)}/content`)
  if (!res.ok) {
    let msg = `读取日志内容失败（HTTP ${res.status}）`
    try {
      const d = await res.json()
      if (d && d.error) msg = d.error
    } catch (e) {
      // 非 JSON 错误体，保留默认文案
    }
    throw new Error(msg)
  }
  return await res.text()
}

// GET /api/client/reports  (API.md 7.3.3，后台读取，需 Bearer)
// Query: project / date / cameraModel / errorCode / uploadOk / ip / page / pageSize
// 返回：{ success:true, data:[{id,ip,project_name,camera_model,error_code,error_reason,upload_ok,report_date,created_at}], pagination:{page,pageSize,total,totalPages} }
export async function getReports(params = {}) {
  const qs = new URLSearchParams()
  if (params.project) qs.set('project', params.project)
  if (params.date) qs.set('date', params.date)
  if (params.cameraModel) qs.set('cameraModel', params.cameraModel)
  if (params.errorCode) qs.set('errorCode', params.errorCode)
  if (params.uploadOk !== '' && params.uploadOk !== undefined && params.uploadOk !== null) qs.set('uploadOk', params.uploadOk)
  if (params.ip) qs.set('ip', params.ip)
  if (params.page) qs.set('page', params.page)
  if (params.pageSize) qs.set('pageSize', params.pageSize)
  const q = qs.toString()
  const res = await auth.request(`/api/client/reports${q ? '?' + q : ''}`)
  if (!res.ok) {
    const err = new Error(`拉取用户数据失败（HTTP ${res.status}）`)
    err.status = res.status
    throw err
  }
  const data = await res.json()
  return {
    list: (data && data.data) || [],
    total: (data && data.pagination && data.pagination.total) || 0,
  }
}



// WEBPACK FOOTER //
// ./src/admin/api.js